export var GLOBAL_STYLESHEET_KEY = '__global__';
export var SHADOW_DOM_STYLESHEET_SETTING = '__shadow_dom_stylesheet__';
export var DEFAULT_SHADOW_CONFIG = {
    stylesheetKey: GLOBAL_STYLESHEET_KEY,
    inShadow: false,
    window: undefined,
    __isShadowConfig__: true,
};
export var makeShadowConfig = function (stylesheetKey, inShadow, window) {
    return {
        stylesheetKey: stylesheetKey,
        inShadow: inShadow,
        window: window,
        __isShadowConfig__: true,
    };
};
export var isShadowConfig = function (obj) {
    if (!obj) {
        return false;
    }
    return obj.__isShadowConfig__ === true;
};
//# sourceMappingURL=shadowConfig.js.map